import React, {useEffect} from "react";
import {connect} from "react-redux";

const AppSettings = ({page, setDynamicSettings}) => {


    useEffect(() => {

        if (!page) return;

        fetch("/wp-json/ensclient/frontendsettings/" + page).then(res => res.json()).then(
            settings => {
                setDynamicSettings(settings);
            }
        )
        ;
    }, [page]);

    return null;
};


export default connect(() => ({}), (dispatch) => ({
    setDynamicSettings: (settings) => dispatch({type: "SETTINGS_LOADED", settings})
}))(AppSettings);